<div class="nav-items">
  @for (item of navService.navItems; track item) {
    @let isNavVisible = navService.isSportVisible(item.name.toLowerCase(), "header") | async;
    @if (isNavVisible) {
      @if (item.name === "Casino") {
        <a (click)="navService.openCasino()" class="nav-item header-tab" target="_blank">
          {{ item.name | translate }}
        </a>
      } @else if (item.name === "Home") {
        <a
          routerLinkActive="header-tab-active is-active-tab"
          [routerLink]="item.path"
          class="nav-item header-tab"
          (click)="goHomeDefaultSport($event)"
          [routerLinkActiveOptions]="{ exact: false }">
          {{ item.name | translate }}
        </a>
      } @else {
        <a routerLinkActive="header-tab-active is-active-tab" [routerLink]="item.path" class="nav-item header-tab">
          {{ item.name | translate }}
        </a>
      }
    }
  }
</div>

<app-m-header />